import React from 'react';

type Props = {
  heightClass?: string;
  widthClass?: string;
  borderRadiusClass?: string;
};

const SkeletonLoader = ({
  heightClass,
  widthClass,
  borderRadiusClass = '',
}: Props) => (
  <div
    data-testid="skeleton-loader"
    className={`${widthClass || 'w-40'} ${
      heightClass || 'h-5'
    } ${borderRadiusClass} m-0 bg-skeleton bg-gradient-to-r from-background-subtle from-30% via-background-regular to-background-subtle to-70% animate-skeleton`}
  />
);

export default SkeletonLoader;
